import { useRef } from 'react';
// import { useMotionValue } from 'framer-motion';
import styled from 'styled-components';
// import { Vector2 } from 'three';

const UnitGrid = styled.div`
  grid-column: 1 / -1;

  position: absolute;
  inset: 0;
  mask-image: linear-gradient(
      to right,
      transparent,
      transparent calc(100% - 1px),
      white calc(100% - 1px),
      white
    ),
    linear-gradient(
      to bottom,
      transparent,
      transparent calc(100% - 1px),
      white calc(100% - 1px),
      white
    );
  mask-size: 32px 32px;
  mask-position: bottom center;
`;

const RadialGradient = styled.div`
  position: absolute;
  inset: 0;
  background-image: radial-gradient(
    circle at 50% 50%,
    ${({ theme }) => theme.palette.fgA800},
    ${({ theme }) => theme.palette.fgA400} 50%
  );
`;

const UnitGridMask = styled.div`
  position: absolute;
  inset: 0;
  mask-image: ${() => {
    const length = 100;
    const stops = Array.from({ length }, (_, i) => i / (length - 1)).map(
      p => `rgba(255 255 255 / ${p}) ${p * 85 + 10}%`
    );
    return `linear-gradient(to bottom, ${stops.join(', ')}, transparent)`;
  }};
  mask-composite: intersect;
`;

// const Cursor = styled.div`
//   position: absolute;
//   isolation: isolate;

//   &::after {
//     content: '';
//     position: absolute;
//     height: 50vw;
//     width: 50vw;
//     border-radius: 999px;
//     background-image: ${({ theme }) =>
//       `radial-gradient(${theme.palette.fgA400} 80%, ${theme.palette.fgA100} 90%)`};
//     transform: translate(-50%, -50%);
//   }
// `;

export function CartesianGrid() {
  // const cursorX = useMotionValue(0);
  // const cursorY = useMotionValue(0);
  // const pointerVec = useState(() => new Vector2(0, 0))[0];
  // const smoothedPointerVec = useState(() => new Vector2(0, 0))[0];
  const gridRef = useRef<HTMLDivElement>(null);

  // useAnimationFrame((_, delta) => {
  //   damp2(smoothedPointerVec, pointerVec, 0.2, delta / 1000);
  //   cursorX.set(smoothedPointerVec.x);
  //   cursorY.set(smoothedPointerVec.y);
  // });

  // useEffect(() => {
  //   function mousemove(e: MouseEvent) {
  //     const node = gridRef.current;
  //     if (!node) return;

  //     const bb = node.getBoundingClientRect();
  //     const x = e.pageX - bb.left;
  //     const y = e.pageY - bb.top;
  //     pointerVec.x = x;
  //     pointerVec.y = y;
  //   }
  //   document.addEventListener('mousemove', mousemove, { passive: true });
  //   return () => {
  //     document.removeEventListener('mousemove', mousemove);
  //   };
  // }, [cursorX, cursorY, pointerVec]);

  return (
    <UnitGrid ref={gridRef}>
      {/* <Cursor as={motion.div} style={{ x: cursorX, y: cursorY }} /> */}
      <UnitGridMask>
        <RadialGradient />
      </UnitGridMask>
    </UnitGrid>
  );
}
